import AlephBet from "alephbet"
import {storage_adapter, lamed_adapter} from "./adapters"
import {on_registration_page, not_logged_in} from "./helpers"
import {registered_successfully} from "./goals"
import $ from "cash-dom"

export default () => {
  const subtitle_variants = new AlephBet.Experiment({
    name: "202505 Subtitle variants",
    tracking_adapter: lamed_adapter,
    storage_adapter: storage_adapter,
    trigger: () => (on_registration_page() && not_logged_in()),
    variants: {
      "1-Original": {
        activate: () => {
        }
      },
      "2-Variant": {
        activate: (experiment) => {
          if (!experiment.options.trigger()) return

          const copy = {
            en: "Almost there! Start learning anatomy now",
            es: "¡Casi listo! Comienza a aprender anatomía ahora",
            pt: "Quase pronto! Comece a aprender anatomia agora!",
            de: "Fast geschafft! Beginne jetzt mit dem Anatomielernen",
            fr: "Presque fini ! Apprenez l’anatomie dès maintenant"
          }

          $(".headline h2").text(copy[window.gon.locale])
        }
      }
    }
  })

  subtitle_variants.add_goals([
    registered_successfully
  ])
}
